import ListItemButton from '@mui/material/ListItemButton';
import Tooltip from '@mui/material/Tooltip';
import type { CSSProperties } from 'react';
import { HighlightedPhrase } from '../../HighlightedPhrase/HighlightedPhrase.tsx';
import { ActionType } from '../types.ts';
import { ITEM_INDENTATION } from '../virtualList/constants.ts';
import { StyledBlockIcon, StyledCheckIcon } from './Icons.styled.tsx';
import { StyledListItemText } from './ListItemText.styled.tsx';

export type ItemReadOnlyProps = {
  actionType: ActionType;
  dataTest?: string;
  depth?: number;
  name: string;
  searchInput: string;
  style: CSSProperties;
};

export const ItemReadOnly = ({
  actionType,
  dataTest = 'item',
  depth = 0,
  name,
  searchInput,
  style,
}: ItemReadOnlyProps) => {
  const isBlockIcon = actionType === ActionType.Block;

  return (
    <ListItemButton
      data-test={dataTest}
      dense
      disableTouchRipple
      role="listitem"
      style={style}
      sx={{ pl: ITEM_INDENTATION + depth }}
    >
      {isBlockIcon ? <StyledBlockIcon data-test="BlockIcon" /> : <StyledCheckIcon data-test="CheckIcon" />}

      <Tooltip title={name} placement="top-start">
        <StyledListItemText
          primary={<HighlightedPhrase searchPhrase={searchInput}>{name}</HighlightedPhrase>}
          disableTypography
        />
      </Tooltip>
    </ListItemButton>
  );
};
